import React from 'react';
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import ReactApexChart from 'react-apexcharts';
import { Card, Box } from '@mui/material';

function AppCurrentVisits(props) {
  const [OUTER_SERIES, setOUTER_SERIES] = useState([]);
    const [INNER_SERIES, setINNER_SERIES] = useState([]);
  useEffect(() => {
    if (props.patients.age) {
      const data = props.patients.age;
      const outerData = [
      data[0]+data[1]+data[2],
      data[3]+data[4],
      data[5],
      data[6]
    ];
    setOUTER_SERIES(outerData);
    setINNER_SERIES(data);
    };
  }, [props.patients.age]);

  // Simplified options without circular references
  const OUTER_OPTIONS = {
    chart: {
      type: 'donut',
      events: {},
      animations: {
        enabled: true
      }
    },
    labels: ['1-17', '18-49', '50-69', '70+'],
    colors: ['#3E8397', '#5ca8bc', '#92c5d3', '#c9e2e9'],
    legend: { show: false },
    plotOptions: {
      pie: {
        donut: {
          size: '58%'
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function(val) {
        return val.toFixed(0) + '%';
      },
      style: {
        fontSize: '16px',
        fontWeight: 'bold'
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        }
      }
    }]
  };

  const INNER_OPTIONS = {
    chart: {
      type: 'donut',
      events: {},
      animations: {
        enabled: true
      }
    },
    labels: [
      '<1', '1-6', '7-17',
      '18-29', '30-49',
      '50-59', '>=70',
    ],
    colors: [
      '#3E8397', '#3E8397', '#3E8397',
      '#5ca8bc', '#5ca8bc',
      '#92c5d3', '#92c5d3',
    ],
    legend: { show: false },
    plotOptions: {
      pie: {
        donut: {
          size: '45%'
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function(val) {
        return val.toFixed(0) + '%';
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        }
      }
    }]
  };

  return (
    <Card sx={{ boxShadow: 'none', mt: 4 }}>
      <Box sx={{ position: 'relative', height: 300 }}>
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 0 }}>
          <ReactApexChart 
            type="donut"
            key="outer-chart"
            series={OUTER_SERIES}
            options={OUTER_OPTIONS}
            height={300}
          />
        </Box>
        <Box sx={{ position: 'absolute', top: 51, left: 0, right: 0, zIndex: 0 }}>
          <ReactApexChart 
            type="donut"
            key="inner-chart"
            series={INNER_SERIES}
            options={INNER_OPTIONS}
            height={200}
          />
        </Box>
      </Box>
    </Card>
  );
}

const mapState = state => ({
  patients: state.overview.patients
});

const mapDispatch = ({
  overview: { loadData }
}) => ({
  loadData: () => loadData()
});

export default connect(mapState, mapDispatch)(AppCurrentVisits);